<script>
import { GlButton, GlBadge, GlTooltip, GlCard } from '@gitlab/ui/';
import { dateTimeMixin } from '../utils/datetime';
import GlMarkdown from './markdown.vue';

const incidentStatuses = ['opened', 'closed'];
export default {
  components: {
    GlButton,
    GlBadge,
    GlTooltip,
    GlMarkdown,
    GlCard,
  },
  mixins: [dateTimeMixin],
  props: {
    incident: {
      type: Object,
      required: true,
      validator: ({ title, status, links }) =>
        typeof title === 'string' && incidentStatuses.includes(status) && 'details' in links,
    },
  },
  computed: {
    statusBadgeVariant() {
      return this.incident.status === 'opened' ? 'danger' : 'success';
    },
  },
};
</script>

<template>
  <gl-card>
    <strong ref="createdAtDateTime">{{ formatDate(incident.created_at) }}</strong>
    <gl-tooltip :target="() => $refs.createdAtDateTime">
      <div class="gl-display-block gl-align-items-center gl-font-sm">
        <div class="gl-mb-2">{{ formatDateTime(incident.created_at) }}</div>
        <div>{{ formatDateTimeZone(incident.created_at) }}</div>
      </div>
    </gl-tooltip>
    <div class="gl-text-gray-900 gl-mt-3">
      <gl-markdown :text="incident.title" />
    </div>
    <gl-badge
      class="gl-display-inline-block gl-mt-3 text-capitalize gl-py-2"
      pill
      :variant="statusBadgeVariant"
    >
      {{ incident.status }}
    </gl-badge>
    <router-link
      :to="{ name: 'details', params: { link: incident.links.details } }"
      class="gl-display-block gl-text-decoration-none!"
    >
      <gl-button
        category="primary"
        variant="default"
        class="gl-font-base gl-mt-5"
        data-qa-selector="incident-link"
      >
        Full report
      </gl-button>
    </router-link>
  </gl-card>
</template>
